import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const cordonImages = {
  Rigide: "/images/CordonR.jpg",
  "Semi-rigide": "/images/CordonSR.jpg",
  "Souple fin": "/images/CordonSf.jpg",
  "Souple épais": "/images/yarn.jpg",
};

const Categories = () => {
  const [cordonTypes, setCordonTypes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/api/products")
      .then((res) => res.json())
      .then((data) => {
        const types = [...new Set((Array.isArray(data) ? data : []).map((p) => p.cordon).filter(Boolean))];
        setCordonTypes(types);
      })
      .catch(() => setCordonTypes([]));
  }, []);

  return (
    <section className="section">
      <div className="container">
        <div className="card cardPad">
          <h2 className="h2" style={{ color: "var(--brand)" }}>Catégories</h2>
          <p className="p">Explore par type de cordon.</p>
        </div>

        <div style={{ height: 18 }} />

        <div style={{ display: "flex", flexWrap: "wrap", gap: 14, justifyContent: "center" }}>
          {cordonTypes.map((cordon) => {
            const img = cordonImages[cordon] || "/images/default.jpg";
            return (
              <button
                key={cordon}
                className="card"
                onClick={() => navigate(`/cordon/${encodeURIComponent(cordon)}`)}
                style={{
                  width: 210,
                  padding: 14,
                  cursor: "pointer",
                  textAlign: "left",
                  background: "var(--card)",
                }}
              >
                <img
                  src={img}
                  alt={`Catégorie ${cordon}`}
                  width="210"
                  height="130"
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: 130,
                    objectFit: "cover",
                    borderRadius: 14,
                    border: "1px solid var(--border)",
                  }}
                  onError={(e) => {
                    e.currentTarget.src = "/images/default.jpg";
                  }}
                />
                <div style={{ marginTop: 10, fontWeight: 900, color: "var(--brand2)" }}>
                  Cordon {cordon}
                </div>
                <div className="p">Voir les modèles →</div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Categories;
